import React from 'react';

function TextError(props: any) {
  return <div className="text-red-600 text-sm">{props.children}</div>;
}

export default TextError;
